import { Phone, MapPin, Facebook } from "lucide-react";

const LOGO_URL = "/logo.png";

export const Footer = () => (
  <footer id="contact" className="bg-[#040404] border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
      <div className="grid lg:grid-cols-4 gap-12">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Premier Cleaning Group" className="h-16 w-16 object-contain" />
            <div>
              <div className="font-serif-display text-2xl gold-grad-text">Premier Cleaning Group</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/40">LLC</div>
            </div>
          </div>
          <p className="mt-6 text-white/55 max-w-md leading-relaxed">
            Commercial, move-in/move-out, and post-construction cleaning. Insured, professional crews — delivering the same elevated standard every single visit.
          </p>
        </div>

        <div>
          <div className="overline text-white/50 mb-5">Contact</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="tel:7573542290" data-testid="footer-phone" className="text-white/85 hover:text-[#D4AF37] flex items-center gap-3">
                <Phone size={14} strokeWidth={1.4} className="text-[#D4AF37]" /> 757-354-2290
              </a>
            </li>
            <li className="text-white/85 flex items-center gap-3">
              <MapPin size={14} strokeWidth={1.4} className="text-[#D4AF37]" /> Hampton Roads, VA
            </li>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61590359970893"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                className="text-white/85 hover:text-[#D4AF37] flex items-center gap-3"
              >
                <Facebook size={14} strokeWidth={1.4} className="text-[#D4AF37]" /> Premier Cleaning Group
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="overline text-white/50 mb-5">Services</div>
          <ul className="space-y-3 text-sm text-white/75">
            <li><a href="#services" className="hover:text-[#D4AF37]">Commercial Cleaning</a></li>
            <li><a href="#services" className="hover:text-[#D4AF37]">Move-In / Move-Out</a></li>
            <li><a href="#services" className="hover:text-[#D4AF37]">Post-Construction</a></li>
            <li><a href="#referrals" className="hover:text-[#D4AF37]">$100 Referral Reward</a></li>
            <li><a href="/admin/login" data-testid="footer-admin-link" className="hover:text-[#D4AF37]">Admin</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 divider-gold" />

      <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
        <div>© {new Date().getFullYear()} Premier Cleaning Group LLC. All rights reserved.</div>
        <div className="italic">
          Vision Brought to Life by&nbsp;
          <a
            href="https://vzngfx.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-vzngfx-link"
            className="text-[#D4AF37] hover:underline not-italic font-medium"
          >
            VZNGFX
          </a>
        </div>
      </div>
    </div>
  </footer>
);
